import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { travelXNewEffects } from 'src/app/travelxnew/store/effects/travelxnew.effects';
import { travelXNewReducers } from 'src/app/travelxnew/store/reducers';
import { travelXNewFeatureKey } from 'src/app/travelxnew/store/selectors';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(travelXNewFeatureKey, travelXNewReducers),
        EffectsModule.forFeature(travelXNewEffects)
    ]
})
export class TravelXNewStoreModule {}
